module.exports = __webpack_public_path__ + "img/video-player/exit-fullscreen-61bae80dd5d14ca96323c859ee9037e7.svg";